import { STORE_FAKE_AUTH, CLEAR_FAKE_AUTH } from '../actions/fakeAuth';
import createMappedReducer from './utils/createMappedReducer';

export const fakeAuth = createMappedReducer(
  {},
  {
    [STORE_FAKE_AUTH](state, action) {
      return action.meta;
    },
    [CLEAR_FAKE_AUTH]() {
      return {};
    },
  },
);
